var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sup-logo" }, [
      _c(
        "div",
        [
          _c("SupsisLogoPurple"),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              { staticClass: "btn-404", on: { click: _vm.btnHome } },
              [_vm._v(_vm._s(_vm.$t("message.page404GoToDashboard")))]
            ),
            _vm._v(" "),
            _c("a", { attrs: { href: "https://supsis.com/" } }, [
              _c(
                "button",
                { staticClass: "btn-404", staticStyle: { right: "60%" } },
                [_vm._v(_vm._s(_vm.$t("message.page404GoToSupsis")))]
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "error-svg",
      attrs: { src: "/static/img/Page404.svg", alt: "404" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }